import { doubleEncode, makePatchRequest } from "../../utils";

type UpdateASessionLiveStreamOptions = {
	sessionId: string;
	stream_url: string;
	stream_key: string;
	page_url: string;
	resolution?: "720p" | "1080p";
};
const updateASessionLiveStream = async (
	token: string,
	options: UpdateASessionLiveStreamOptions,
) => {
	await makePatchRequest({
		token,
		pathList: [
			"v2",
			"videosdk",
			"sessions",
			doubleEncode(options.sessionId),
			"livestream",
		],
		options: {},
		body: {
			stream_url: options.stream_url,
			stream_key: options.stream_key,
			page_url: options.page_url,
			resolution: options.resolution,
		},
	});
	return 204;
};
export const curriedUpdateASessionLiveStream = (token: string) => (options: UpdateASessionLiveStreamOptions) => updateASessionLiveStream(token, options);
